import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { BaseLayoutComponent } from './modules/base-layout';
import { LoginComponent } from './modules/login/login.component';
import { P404Component } from './modules/error/404.component';
import { P500Component } from './modules/error/500.component';
import { RouteAuthGuard } from './modules/route-auth-guard';
import { BlockFacilitiesComponent } from './modules/block-facilities/block-facilities.component';
import { StatementsComponent } from './modules/block-facilities/statements/statements.component';
import { CoreDetailChangesComponent } from './modules/block-facilities/core-detail-changes/core-detail-changes.component';

export const routes: Routes = [
  {
    path: '500',
    component: P500Component,
    data: { title: '500 Server Error' },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: BaseLayoutComponent,
    data: { title: 'GT Portal - Dashboard' },
    canActivate: [RouteAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./modules/users-management/users-management.module').then(
            (m) => m.UsersManagementModule,
          ),
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('./modules/audit-trail/audit-trail.module').then(
            (m) => m.AuditTrailModule,
          ),
      },
      {
        path: 'taxpayer',
        loadChildren: () =>
          import('./modules/taxpayer/taxpayer.module').then(
            (m) => m.TaxpayerModule,
          ),
      },
      {
        path: 'run-management',
        loadChildren: () =>
          import('./modules/run-management/run-management.module').then(
            (m) => m.RunManagementModule,
          ),
      },
      {
        path: 'block-facilities',
        component: BlockFacilitiesComponent,
        children: [
          {
            path: '',
            redirectTo: 'statements',
            pathMatch: 'full',
          },
          {
            path: 'statements',
            component: StatementsComponent,
          },
          {
            path: 'core-detail-changes',
            component: CoreDetailChangesComponent,
          },
        ],
      },
    ],
  },
  {
    path: '**',
    component: P404Component,
    data: { title: '404 Not Found' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
